(function() {
    'use strict';

    angular
        .module('app')
        .directive('dotdotdot', dotdotdot);

    dotdotdot.$inject = ['$window'];
    
    function dotdotdot ($window) {
        // Usage:
        //     <dotdotdot></dotdotdot>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                maxHeight: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.$watch(function () {
                element.dotdotdot({ watch: true });
            });
        }
    }

})();